import {
    CANCELLATION_CHANNELS,
    buildDefaultChannelSelection,
    formatAppointmentDateTime,
    formatPatientName,
    getChannelState,
    getRowChannelSelection,
    getRowKey,
} from './cancellationFollowupChannel';

const escapeHtml = (value) => {
    if (value == null || value === '') {
        return '';
    }

    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
};

const formatChannelCell = (record, channelKey, selectedChannel) => {
    const state = getChannelState(record, channelKey);

    if (state.disabled) {
        return '—';
    }

    return selectedChannel === channelKey ? 'Yes' : 'No';
};

const buildRecordRows = (records, channelSelections) =>
    records
        .map((record) => {
            const rowKey = getRowKey(record);
            const selectedChannel = getRowChannelSelection(channelSelections, rowKey, record);

            const channelCells = CANCELLATION_CHANNELS.map(
                (channel) => `<td class="center">${escapeHtml(formatChannelCell(record, channel.key, selectedChannel))}</td>`
            ).join('');

            return `
                <tr>
                    <td>${escapeHtml(formatPatientName(record))}</td>
                    <td>${escapeHtml(record.email || '—')}</td>
                    <td>${escapeHtml(record.cellPhone || '—')}</td>
                    <td>${escapeHtml(record.homePhone || '—')}</td>
                    <td>${escapeHtml(formatAppointmentDateTime(record))}</td>
                    ${channelCells}
                </tr>
            `;
        })
        .join('');

export const buildCancellationFollowupsPrintSubtitle = ({
    recordsCount,
    totalElements,
    pageNumber,
    totalPages,
}) => {
    const pageLabel = `Page ${totalPages === 0 ? 0 : pageNumber + 1} of ${Math.max(totalPages, 1)}`;
    return `${recordsCount} shown · ${totalElements} total · ${pageLabel}`;
};

export const printCancellationFollowupsList = ({ records, channelSelections, title, subtitle }) => {
    if (!records?.length) {
        return false;
    }

    const channelHeaders = CANCELLATION_CHANNELS.map((channel) => `<th>${escapeHtml(channel.label)}</th>`).join('');
    const html = `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8" />
  <title>${escapeHtml(title)}</title>
  <style>
    body { font-family: Arial, Helvetica, sans-serif; color: #111827; margin: 24px; }
    h1 { font-size: 20px; margin: 0 0 4px; }
    .subtitle { color: #6b7280; margin-bottom: 16px; font-size: 0.78rem; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th, td { border: 1px solid #e5e7eb; padding: 8px; text-align: left; }
    th { background: #f9fafb; text-transform: uppercase; font-size: 11px; letter-spacing: 0.04em; }
    td.center, th.center { text-align: center; }
  </style>
</head>
<body>
  <h1>${escapeHtml(title)}</h1>
  <div class="subtitle">${escapeHtml(subtitle || '')}</div>
  <table>
    <thead>
      <tr>
        <th>Patient</th>
        <th>Email</th>
        <th>Cell Phone</th>
        <th>Home Phone</th>
        <th>Missed Appointment</th>
        ${channelHeaders}
      </tr>
    </thead>
    <tbody>
      ${buildRecordRows(records, channelSelections)}
    </tbody>
  </table>
</body>
</html>`;

    const printWindow = window.open('', '_blank', 'noopener,noreferrer,width=1024,height=768');
    if (!printWindow) {
        return false;
    }

    printWindow.document.open();
    printWindow.document.write(html);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    return true;
};

// Keep default selection helper available for print consumers that still expect it.
export { buildDefaultChannelSelection };
